import FormWizard from './components/fullProfile'
import DashboardLayout from './layout'
import { useTranslation } from 'react-i18next'

function ProfilePage() {
  const { t } = useTranslation()
  return (
    <div className='w-full overflow-x-hidden'>
      {' '}
      {/* 👈 Ici la correction */}
      <DashboardLayout title={t('create-ad.profile')}>
        <FormWizard userProfileFormProps={undefined} />
      </DashboardLayout>
    </div>
  )
}

export default ProfilePage
